import * as React from 'react';
import classNames from 'classnames';

import ActionLink from 'components/buttons/action-link/ActionLink';
import DeliverableInfoCopyControl from '../deliverable-info-copy-control/DeliverableInfoCopyControl';
import Tooltip from 'components/Tooltip';

import { DeliverableLink } from 'types';

import './deliverable-link-view.scss';

type Props = {
  deliverableId: number,
  deliverableLink: DeliverableLink,
  title: string,
  descriptionTitle: string,
  index: number,
  nameTitle?: string,
  isMultiZLinkEnabled?: boolean
}

const DeliverableLinkView = ({
  deliverableId,
  deliverableLink,
  title,
  descriptionTitle,
  index,
  nameTitle,
  isMultiZLinkEnabled }: Props) => {
  const { url, description, name } = deliverableLink;

  const descriptionClass = classNames('deliverable-link-view__link-description-container', {
    'deliverable-link-view__link-description-container--name': isMultiZLinkEnabled
  });

  return (
    <React.Fragment key={`${deliverableId}-${url}`}>
      <div className="deliverable-link-view__link">
        <div className="deliverable-link-view__section-title">
          {title}
          <DeliverableInfoCopyControl
            uniqueKey={`${deliverableId}-${url}-url-${index}`}
            wrapperClass="deliverable-link-view__copy"
          />
        </div>
        <div>
          <Tooltip
            message={url}
            width="auto-compact"
            trigger="hover"
            classNameWrapper="deliverable-link-view__url-wrapper"
          >
            <ActionLink
              openInNewTab
              size="inherit"
              decoration="none"
              link={url}
              className="deliverable-link-view__url text-overflow-ellipsis"
            >
              <span
                data-copy-key={`${deliverableId}-${url}-url-${index}-field-to-copy`}
              >
                {url}
              </span>
            </ActionLink>
          </Tooltip>
        </div>
      </div>
      {
        isMultiZLinkEnabled && (
          <div className="deliverable-link-view__link-name">
            <div className="deliverable-link-view__section-title">
              {nameTitle}
              <DeliverableInfoCopyControl
                uniqueKey={`${deliverableId}-${url}-name-${index}`}
                wrapperClass="deliverable-link-view__copy"
              />
            </div>
            <div
              className="deliverable-link-view__link-name"
              data-copy-key={`${deliverableId}-${url}-name-${index}-field-to-copy`}
            >
              {name}
            </div>
          </div>
        )
      }
      <div className={descriptionClass}>
        <div className="deliverable-link-view__section-title">
          {descriptionTitle}
          <DeliverableInfoCopyControl
            uniqueKey={`${deliverableId}-${url}-description-${index}`}
            wrapperClass="deliverable-link-view__copy"
          />
        </div>
        <div
          className="deliverable-link-view__link-description"
          data-copy-key={`${deliverableId}-${url}-description-${index}-field-to-copy`}
        >
          {description}
        </div>
      </div>
    </React.Fragment>
  );
};

export default DeliverableLinkView;
